import Vue from 'vue'
import router from '../../router'
import VueCookies from 'vue-cookies'
import api from '../../api/leadRealAPI'

Vue.use(VueCookies)

export default {
  namespaced: true,

  state: {
    blogList: {},
    deleteMsg: null
  },

  getters: {
    blogList: state => state.blogList,
    deleteMsg: state => state.deleteMsg
  },

  mutations: {
    setBlogList (state, blogList) {
      state.blogList = blogList
    },
    setDeleteMsg (state, deleteMsg) {
      state.deleteMsg = deleteMsg
    }
  },

  actions: {
    getBlogList ({ commit }) {
      api
        .get('admin/getBlogList')
        .then(response => {
          commit('setBlogList', response.data)
        })
        .catch(() => {})
    },
    getBlogSpecific ({ commit }, data) {
      commit('setBlogList', null)
      api
        .get('admin/blogSpecific/' + data)
        .then(response => {
          commit('setApiStatus', null, { root: true })
          commit('setBlogList', response.data.data)
        })
        .catch(() => {})
    },
    updateStatus ({ state, commit }, data) {
      const language = data.language
      state.blogList.blog_categories[language] = data.status
    },
    newBlog ({ commit }, data) {
      const dataImage = new FormData()
      if (data.image !== null) {
        dataImage.append('imageName', data.image.name)
        dataImage.append('file', data.image)
      }
      dataImage.append('value', JSON.stringify((data)))
      api
        .post('admin/registerBlog', dataImage, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(response => {
          const id = response.data.data.id
          const blog = response.data.data.blog_articles_details[0]
          router.push({ name: 'Blog Editing Language', params: { id: id, language: blog.language } })
          commit('setApiStatus', response.data.status, { root: true })
          setTimeout(() => commit('setApiStatus', null, { root: true }), 3000)
        })
        .catch(() => {})
    },
    updateBlog ({ commit, dispatch }, data) {
      const dataImage = new FormData()
      if (data.newImage !== null) {
        dataImage.append('imageName', data.newImage.name)
        dataImage.append('file', data.newImage)
      }
      dataImage.append('value', JSON.stringify((data)))
      api
        .post('admin/blogUpdate/' + data.id, dataImage)
        .then(response => {
          dispatch('getBlogSpecific', response.data.data.id)
          commit('setApiStatus', response.data.status, { root: true })
          setTimeout(() => commit('setApiStatus', null, { root: true }), 3000)
        })
        .catch(() => {})
    },
    deleteBlog ({ commit }, data) {
      api
        .post('admin/blogDelete/' + data)
        .then(response => {
          commit('setDeleteMsg', response.data.status)
          setTimeout(() => commit('setDeleteMsg', null), 3000)
          router.push({ name: 'Blog List' })
        })
        .catch(() => {
          Vue.$cookies.remove('access_token')
        })
    }
  }
}
